import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Timeout generoso (60s) para soportar exports grandes y conexiones lentas;
// Chrome aborta peticiones largas con timeout corto y desencadena logouts falsos.
const api = axios.create({ baseURL: API, timeout: 60_000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Reintento silencioso para errores transitorios de infraestructura
// (Cloudflare 520/522/524, gateway 502/503/504, timeouts de red). Estos suelen
// ocurrir cuando el pod de producción se reinicia o hay presión momentánea;
// un reintento en 500-1500 ms suele resolverlos sin que el usuario los vea.
const _RETRY_STATUSES = new Set([502, 503, 504, 520, 521, 522, 523, 524]);
const _MAX_RETRIES = 2;

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const status = error?.response?.status;
    const config = error?.config || {};
    // Solo cerramos sesión con 401 REAL del backend.
    if (status === 401) {
      localStorage.removeItem("fc_token");
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
    // Decidir si reintentamos: 5xx transitorio o error de red sin response.
    const isTransientNetwork = !error?.response && (error?.code === "ECONNABORTED" || error?.code === "ERR_NETWORK");
    const isTransientStatus = status && _RETRY_STATUSES.has(status);
    if (config && (isTransientNetwork || isTransientStatus)) {
      config.__retryCount = (config.__retryCount || 0) + 1;
      if (config.__retryCount <= _MAX_RETRIES) {
        const delay = 400 + config.__retryCount * 600; // 1000ms, 1600ms
        await new Promise((r) => setTimeout(r, delay));
        return api(config);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
